import React from 'react';

const CategoryGrid: React.FC = () => {
  return (
    <section className="py-8 md:py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Grid Layout: 3 columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 auto-rows-fr">

          {/* Prologo - Top Left */}
          <div className="relative group overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 aspect-square">
            <img
              src="/categorygrid/prologo.jpg"
              alt="Prologo"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />

          </div>

          {/* Zipp - Top Center */}
          <div className="relative group overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 aspect-square">
            <img
              src="/categorygrid/zipp.jpg"
              alt="Zipp"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />

          </div>

          {/* Maap - Top Right, spans 2 rows on desktop */}
          <div className="relative group overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 aspect-square md:row-span-2 md:aspect-auto">
            <img
              src="/categorygrid/maap.jpg"
              alt="Maap"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />

          </div>

          {/* Duraace (Jacob) - Bottom Left, spans 2 columns */}
          <div className="relative group overflow-hidden rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 md:col-span-2 aspect-video">
            <img
              src="/categorygrid/duraace.jpg"
              alt="Dura-Ace"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />

          </div>

        </div>
      </div>
    </section>
  );
};

export default CategoryGrid;
